import styled from 'styled-components'
import type { ColorKeys } from '../styles/colors'

const StyledLogo = styled.svg<{ $color: ColorKeys }>`
  path {
    fill: ${ p => p.theme.getColor( p.$color ) };
  } 
`

function Logo( { color = 'navy' as ColorKeys } ) {
  return (
    <StyledLogo
      $color={ color }
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 86.05 88.84"
    >
      <path 
        d="M13.4,45.55c.89,2,3.61,1.07,3.62-.94-.34-1.57-1.47-6.76-3-3C13.67,42.89,12.8,44.29,13.4,45.55Zm.89-1.46a12.79,12.79,0,0,1,.81-2.3C17.32,46.15,14,46.7,14.29,44.09Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M19.22,49.8c.76,2,3.67,1.05,3.59-.91a9.09,9.09,0,0,0-1.17-3.53c-.61-2-1.34-.52-1.84.56S18.63,48.52,19.22,49.8Zm.83-1.47a20.56,20.56,0,0,1,.83-2.19C23.18,49.83,20,51.33,20.05,48.33Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M25,45.52a1.91,1.91,0,0,0,3.63-.9c-.08-1.17-1.52-6.56-2.76-3.53C25.32,42.47,24.46,44,25,45.52Zm.9-1.48a12.56,12.56,0,0,1,.79-2.2C29,45.25,25.85,47.22,25.89,44Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M34.37,48.17c-.4-1.05-1.56-5.6-2.61-2.83-.66,1.36-1.54,3.19-.83,4.67C32.22,52.09,35,50.26,34.37,48.17Zm-1.12,1.24c-.47.87-1.54.4-1.56-.49a9.14,9.14,0,0,1,.81-2.76C32.89,47.13,33.66,48.35,33.25,49.41Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M36.68,45.56a1.83,1.83,0,0,0,3.49-.76c.13-1.16-1.35-6.68-2.66-3.75C37,42.45,36,44.09,36.68,45.56Zm.84-1.48c.25-.7.48-1.59.8-2.28C40.59,45.93,37.36,46.8,37.52,44.08Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M52.37,29.65c-.85-3.27-5.85-1.76-5,1.46C48.45,34.36,53.46,33,52.37,29.65Zm-.93,1.24a1.6,1.6,0,0,1-3-1A1.6,1.6,0,0,1,51.44,30.89Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M61.43,72.22A33.56,33.56,0,0,0,61,15.87C38.14,1.73,8.84,18.76,9.8,45.56,10.93,71.34,39.71,86.19,61.43,72.22ZM66.08,67a29.42,29.42,0,0,1-3.93,3.39,11.9,11.9,0,0,0-2.6,0c-3,1.38-5.09,2-8.22.29-3.11-1.07-1.95.91-3.1-2.7-.36-.71-1-1.43-1.35-2.12a6.74,6.74,0,0,1,2.89-.38c2.23.45,4.4,2,6.75,1.27,1.3-.24,2.44-1.25,3.77-1.34,2.12-.2,3.89,1.23,5.9,1.5Zm-26.27.29c1.1-1.48,2.55-4.21,1-5.77-2.31-.31-4.77-1.57-5.12-4.1,2.76,1.91,5.54-.32,7.56,2.87.79-.09.46-1.39,1.34-1.51,1.92-.76,4.27-.05,6.09-1.29-.89,5.78-7.71,1.35-5.24,8,.85,1.59,2.25,3,2.4,4.91-2.58.85-4.16,2.18-7,.87a6.82,6.82,0,0,0-2.27-.86A12.41,12.41,0,0,1,39.81,67.28Zm31.9-7.65a41.32,41.32,0,0,1-3,4.43c-.84,1-1.54,2.27-3,1.72-1.74-.64-3.49-1.53-5.41-1.41a10.43,10.43,0,0,0-3.4,1.18C53.22,66.86,50.2,63,46.35,65c-1.83-4.24,3-1.6,4.74-5.56a7.88,7.88,0,0,0,5.47,1.05c6.2-2.92,5-.38,10.33.13,1.8.12,3.3-1.1,5-1.38Zm-5.6-38.35a33.07,33.07,0,0,1,9.3,26.28,32.11,32.11,0,0,1-.9,4.57c0,.93-.29,1.17-1.21,1-1.81,0-3.69.1-5.5,0-.41-.11-1.72.3-1.63-.27.07-5.88,0-11.8.06-17.67-.06-2.27,0-4.63,0-6.91-.33-1.14-3.72-.17-4.78-.43-1.43.34-5.71-1.09-5.46,1.18,0,3.72,0,7.46,0,11.19,0,.65.06,1.49.05,2.13-1.14.25-3.65-.66-3.37,1.27,0,1.94,0,4,0,5.91-.18.81.58,4-.5,3.72-2.46-.09-4.95-.1-7.41,0-1.74.12-.85-1-1.05-2.24,0-2.44-.06-4.93,0-7.37-.06-7.22.06-14.5,0-21.74a2.67,2.67,0,0,0,3.88-.56,2.73,2.73,0,0,0,4.43.08c.89,1.59,3.25,1.31,4.29,0a2.72,2.72,0,0,0,4.44-.05c1.07,1.89,4,1.25,4.74-.62A4.49,4.49,0,0,0,66.11,21.28ZM53.73,50.87c0-2.41,0-4.87,0-7.28,4.71-.48,3.07.38,3.32-4.64,0-2.65.1-5.34-.06-8,.22-.48-.27-2.16.31-2.08,2.05-.19,4.19.19,6.25-.07,1.66.13,1.76-.38,1.57,1.54,0,1.79,0,3.64,0,5.42.17,5.22-.1,10.5.07,15.72-.15.67.35,2-.82,1.65a51.05,51.05,0,0,1-6.06,0c-1.34,0-2.76,0-4.09.08C53.36,53.53,53.9,51.28,53.73,50.87Zm-9.85-39a33.29,33.29,0,0,1,16.46,4.86c.86.88,5.12,2.76,3.92,4.08a1.61,1.61,0,0,1-2.62,0c-.24-.65-.68-2.36-1.45-1.06a1.73,1.73,0,0,1-2.66,1.49c-.63-.41-.74-3-1.74-1.45a1.76,1.76,0,0,1-2.17,1.66c-1.19-.09-.85-2.84-2.11-1.91a1.76,1.76,0,0,1-2.69,1.65c-.17-.2-.51-.62-.67-.84,0-.38.08-1-.44-1-.86-.08-.47,1.05-1,1.44a1.7,1.7,0,0,1-2.92-.38,43.89,43.89,0,0,1,0-6.28C43.89,13.52,43.38,12,43.88,11.82ZM13.3,31.87c.46-.91.77-2.57,1.72-2.93,2.28.18,4.59,0,6.86.07,3.9,0,7.81,0,11.7,0,4.72.49,9-2.68,6.16-7.48C37,18.27,30.86,20.74,33,25.12c1.42,2.05,5.55.92,4.67-1.79-.48-1.31-2-.6-.93.47.16,1.38-1.64,1.63-2.57,1.05-2.81-4.75,6.33-5.2,5.33,0-.3,2.87-3.66,3.16-6,3.09-6.11-.07-12.24,0-18.34-.06.83-2.06,1.59-1.56,3.47-1.5,2.88-.17,5.94.14,8.81-.12,3.13-.58,4.32-5,1.24-6.54-2.46-1.5-6.26,1.23-4.17,3.83.53.76,2.29.43,1.24-.5-.73-.15-.84-.87-.74-1.5,3-4,7.36,2.82,1.68,3.77-3.25,0-6.61.05-9.85-.05,5.78-7.9,15.15-13.24,25-13.41,1.13-.4.67.75.82,1.47,0,1.3-.14,2.69,0,4-.07,4.7.05,9.42,0,14.11.26,1-2.85.38-3.57.48-2,.12-4.16,0-6.19.08-6.55-.09-13.2,0-19.73,0ZM12.05,52.81a31.21,31.21,0,0,1,.81-19.75c7.82-.12,15.71-.05,23.54,0,1.56-.1,3.2,0,4.76,0,0,0,1.49-.06,1.5,0,.14,1.26-.06,2.62.06,3.87-.14,3.77.09,7.58-.1,11.36.15,1.54,0,3.26.07,4.8-.2.34-1.59,0-2,.1-6.28,0-12.58.08-18.86,0-2.22.08-4.5,0-6.71,0C14.41,53,12.11,53.65,12.05,52.81Zm1.06,3.13c-.17-.52-.55-1.16-.7-1.68,20.5-.15,41,0,61.54,0a35.52,35.52,0,0,1-1.49,3.87,10.42,10.42,0,0,0-1.85.35,7.11,7.11,0,0,1-7.5,0C59.85,57,58,59.46,55,59.5a5.93,5.93,0,0,1-3.4-1c-.15-.65.41-1.8.14-2.54-.61-.79-1.15.54-1.75.69a10.73,10.73,0,0,1-1.83.64c-1.66.12-3.81-.16-5,1.24-1.45-1.47-3.78-1.08-5.63-1.36-1.26-.15-3.25-3-3-.17,0,.4.48,1.38.16,1.57a6.19,6.19,0,0,1-3.33.91c-2.77.1-4.84-2.51-8-1-2.11,1.11-4.63,1.55-6.76.22C14.47,57.68,13.64,58.84,13.11,55.94Zm5.38,9.16a33.75,33.75,0,0,1-4-6c1.74.17,3.3,1.72,5.13,1.4,2.08.21,3.84-1.44,5.87-1.48,2.8.26,4.46,2.18,7.46,1.29.91.24,2.16-1.5,2.61-.49,2.32,3.51,6.16.94,4.45,5.07-3.22-1.78-6,1.08-9.22.93-1.55-.13-2.94-1.28-4.52-1.38C23.63,63.68,19.76,67.28,18.49,65.1Zm4.85,4.59a21.83,21.83,0,0,1-3.23-2.85c2.39-.47,4.74-2.07,7.23-1.06,1.53.61,3.16,1.5,4.85,1,2-.19,3.71-1.63,5.79-1.39.93.19,2.1.19,1,1.27a15,15,0,0,0-1.48,3.39c.14.46-.74.09-.95.2a9.76,9.76,0,0,0-3.26,1.23c-2.19.64-4.25-.26-6.23-1.09C25.78,70,24.2,71,23.34,69.69Zm37,1.91a32.25,32.25,0,0,1-34.68-.27c1.57,0,2.9,1,4.39,1.33,2.84.52,4.15-.71,6.66-1.35,2.32-.22,4.18,1.49,6.48,1.5,2.18.33,3.84-1.75,6-1.42,1.83-.21,3.37,1.33,5.17,1.38,2.36.49,4.27-1.44,6.52-1.41Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M14.09,71.89c-.45-.46-.94-1.2-1.42-1.63a7.91,7.91,0,0,0,1.06-1c.38.6,1.08,1.25,1.51,1.81.26-.24.81-.7,1.09-.91-.83-1-1.76-2-2.62-3-1.8,1.54-3.56,3.24-5.46,4.68,1.44,2.35,1.82.29,3.37-.69C12.63,72.17,12.81,73.46,14.09,71.89Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M20.9,77.87c2.27-4.34-4.62-8.1-6.84-3.61C11.66,78.43,18.67,82.36,20.9,77.87ZM19.53,77c-1.24,2.63-5.05.84-4.16-1.8A2.27,2.27,0,0,1,19.53,77Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M26.9,78.14a7.74,7.74,0,0,0-2.14-1.37c-.59-.31-1.18-1.07-1.45-.07-.83,2-2,3.89-3,5.8,2.09,1.35,1.84-.18,2.8-1.74.27,1.95-.11,3.73,2.2,4.34-.16-1.16-.38-2.47-.59-3.63A2.15,2.15,0,0,0,26.9,78.14Zm-1.4,1.5c-.42.78-1.29.58-1.92.15a14.57,14.57,0,0,1,1-1.72A1.36,1.36,0,0,1,25.5,79.64Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M34.78,80.54C33,79.41,30.4,81,31.34,83.16c.37,1,2.17,1.12,2.17,2.33-.73,1.05-2,.21-2.53-.62C29,86,30.56,86.79,32,87.48c1.9.61,4-1.31,3-3.22-.46-.7-1.51-1.06-2.07-1.71-.19-1.37,1.55-.82,2-.07C36,81.56,36.16,81.2,34.78,80.54Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M41.45,81.4a3.85,3.85,0,0,0-3.87,6.15,4.29,4.29,0,0,0,4.41,1c-.09-.59.17-1.33.11-1.92a2.22,2.22,0,0,1-3.58-2.38,2.26,2.26,0,0,1,3.86-.49C42.2,82.36,43.19,81.94,41.45,81.4Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M50.3,86.94c-.1-1.49-.28-3-.44-4.53,0-1.75-.34-1.13-1.73-1.15.2.85.1,1.88.28,2.73a11.6,11.6,0,0,1-1.44.09c-2.08.73-1.45-1.24-1.64-2.6-1.21.27-2-.1-1.52,1.49a38.32,38.32,0,0,0,.43,4.54c-.16,1.66.41,1.29,1.74,1.16-.11-.68-.14-1.61-.24-2.28-.32-1,.66-.86,1.37-.85s1.6-.47,1.5.58a12.06,12.06,0,0,0,.22,2.24C50.18,88.28,50.75,88.57,50.3,86.94Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M59.27,82.08c-1.41-4.74-9.05-2.37-7.36,2.34C53.11,89.16,60.9,86.63,59.27,82.08Zm-1.53,1.67c-.63,2.78-4.92,1.78-4.36-1A2.24,2.24,0,0,1,57.74,83.75Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M67.28,77.54c-2.61-4.2-9.21-.34-6.68,4S69.8,81.65,67.28,77.54Zm-1.13,2.57c-.85,2.75-5.08,1.56-4.44-1.21A2.31,2.31,0,0,1,66.15,80.11Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M72.9,75.49c-.56.4-1.13,1.13-1.69,1.53-1-1.34-2.22-2.64-3.29-4-.5-1-1.18.25-1.74.61,1,1.1,2,2.39,3,3.45,2.11,3.41,2.25,1.07,4.6-.52A5.09,5.09,0,0,1,72.9,75.49Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M76.89,70.72c-.63-1.26-2.33-1.09-3.31-.34-1.38,1-2-.49-.7-1.24.59-.06.63-.36.45-.86s-.42-.72-1-.5c-1.5.82-2.68,2.91-1.07,4.23,1.16,1.15,2.49-.15,3.7-.48,1.84.17,0,2.4-1.21,2,.38,1.12.28,1.79,1.67,1.19S78.08,72.2,76.89,70.72Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M7.05,31.69C6.26,31,5.4,30.21,4.59,29.56c1,0,2.21,0,3.26.06.66.12,1.51.32,1.51-.61.85-1.1-1.3-1.57-1.83-2.38-1.28-.92-2.47-2.11-3.71-3.08a5.62,5.62,0,0,1-.65,1.63,46.42,46.42,0,0,1,3.91,3.08c-.88-.07-1.94-.06-2.82-.09s-2.08-.58-2.37.36c-.55.92,1.05,1.27,1.47,1.93.85.35,1.49,1.24,2.24,1.72-1.37-.12-2.86,0-4.24-.21-1.08-.31-.94,1-1.36,1.6,2.52-.09,5.11.21,7.63.27C8.14,32.85,8.15,32.2,7.05,31.69Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M6.59,22.06c1.89,4.74,8.84,1.66,7.19-2.84C11.91,14.41,5,17.39,6.59,22.06ZM8,20.4c.29-2.95,4.7-2.36,4.46.47A2.24,2.24,0,0,1,8,20.4Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M12.27,14.48l4,4.32a11.84,11.84,0,0,0,1.19-1.16c-.63-.61-1.24-1.46-1.9-2.07,2,.41,3.34,1.43,4.79-.61-1.13-.27-2.43-.43-3.58-.66a2.13,2.13,0,0,0-3-2.88c-.82.6-1.59,1.44-2.36,2.1Zm1.49-1.4c2.41-1.6,2,2.64.56,1.26C14.23,13.89,13.17,13.4,13.76,13.08Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M17.9,9.61c.75,1.29,1.7,2.55,2.53,3.79.61,1.28.75,1,1.83.4.48-.81,2.8-1.13,1.73-2.09-.47-1.13-1.6.34-2.25.71-1-1.6-2.25-3.15-3.23-4.8C17.49,8.4,16.73,8.41,17.9,9.61Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M22.66,6.5c.88,1.75,1.69,3.56,2.48,5.35,2.25-.86,5.05-2.36,4.34-5.23A3.5,3.5,0,0,0,24.8,4.17a13.94,13.94,0,0,0-2.64,1.14A4.77,4.77,0,0,1,22.66,6.5Zm2-.78c2.91-1.65,4.67,3.46,1.44,4.07-.6-1.28-1.27-2.65-1.9-3.92Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M34,6c2.43,4.18,9.32.37,6.66-3.91C38-2,31.48,1.63,34,6ZM35.21,3.2a2.29,2.29,0,0,1,4.24,1.74A2.29,2.29,0,0,1,35.21,3.2Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M43.3,5.68c.81,1.74,3.11,2.13,4.78,1.56a17.34,17.34,0,0,1,.05-1.91c-5.28,3.16-4.37-6.6.14-2.9C49.68-2.37,40.31.41,43.3,5.68Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M50.65,7.94c.8.3,1.84.35,2.65.66.56-2.29-.35-1.29-2.08-1.92.1-2.24.93-1.36,2.57-1.07.76-2-.4-1.44-1.95-1.82.11-.34.28-1,.35-1.36.74.14,1.62.34,2.35.53.18-1.42.63-1.49-1-1.75-.88.19-2.71-1.14-2.8.11-.3,1.69-.87,3.39-1.07,5.1C49.05,7.68,49.43,7.77,50.65,7.94Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M54.33,8.09l-.53.51c3.34,1.81.7-1.56,4.55.34,1.79.59-1.09,1.46,2.18,2.39,0-1.61.06-3.29,0-4.9-.22-1,.74-2.86-.63-3.07-1-.82-1.41.76-2.17,1.23C56.67,5.76,55.37,6.86,54.33,8.09Zm3.5-1.33c.41-.42.85-1.09,1.29-1.47-.06.83,0,1.81-.08,2.63a16.4,16.4,0,0,0-1.61-.71Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M62.52,12.61c.83-1.25,1.82-2.5,2.61-3.78.2,1.52.27,3.14.49,4.65a2,2,0,0,0,1.29,2.1c.62-.83,1.21-1.83,1.87-2.62a31,31,0,0,1,1.84-2.68c.71-.71-.52-1.13-1-1.5C68.7,10,67.82,11.36,67,12.63c-.07-1.31-.31-2.72-.37-4s-.23-2.35-1.41-2.87c-.92,1.72-2.36,3.19-3.29,4.9C60.69,11.88,61.41,11.81,62.52,12.61Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M69.85,18.47c2.14,2.62,4.08,4.81,7.27,2,1.95-2.48-.11-4.6-1.69-6.56C73.62,15.42,71.77,17,69.85,18.47Zm2.74-.08c1.09-.57,2.72-3.26,3.49-1.47a2.26,2.26,0,0,1-2.35,3.19C73,19.89,71.3,18.94,72.59,18.39Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M78.81,28.18c1.17-1.43,2.42-2.88,3.62-4.3-.77-1.18-.61-1.52-2.15-1.12-2.12.06-4.23.56-6.33.63,1,2.9,1.86.41,2.65,2,2.14,3.3-1.24,1.55.84,4.4C77.78,29.23,78.42,28.67,78.81,28.18Zm-.87-3.09-.29-.47c.77-.17,1.71-.25,2.49-.39-.45.67-1.18,1.25-1.68,1.86A2.52,2.52,0,0,1,77.94,25.09Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M85.84,32.58c0-1.61-1.74-1.52-2.93-1.89,1.44-2,2-1.33,1-4C83,28,82.05,29.24,81.07,30.39c-.86.73-3.57.42-2.92,1.92.55,1.81,2.81-.9,4.12-.14,1.2.41,2.55.71,3.78,1Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M19.13,40.44c1,2.36,4.34.65,3.6-1.59s-1.63-5.92-3.22-1.57A7,7,0,0,0,19.13,40.44Zm1-1.42a7.78,7.78,0,0,1,.77-2.2C23.17,40.93,19.7,41.69,20.14,39Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M30.9,40.53a1.87,1.87,0,0,0,3.54-.72c0-1.62-1.72-7.24-3-3.1C31,37.87,30.18,39.33,30.9,40.53ZM31.7,39a21.34,21.34,0,0,1,.81-2.28C34.72,40.68,31.63,41.82,31.7,39Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M62.26,32.24c.55,0,2.55.4,1.86-.78C63.52,30.89,60.57,31.28,62.26,32.24Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M58.75,32.26c.6-.16,2.2.36,2-.73C60.26,30.6,57,31.43,58.75,32.26Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M62.3,35.67c.76.15,3-.31,1.44-1.09C63,34.39,60.74,34.89,62.3,35.67Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M58.73,35.56c.58-.07,1.91.43,2-.45C60.65,33.9,56.84,34.64,58.73,35.56Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M62.28,38.9c.55,0,2.58.3,1.84-.85C63.5,37.51,60.55,38,62.28,38.9Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M58.75,39c.55,0,2.57.25,1.82-.89C59.94,37.57,57,38.13,58.75,39Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M62.3,42.33c.61,0,2.55.16,1.79-1C63.4,40.88,60.57,41.52,62.3,42.33Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M58.75,42.37c.65-.09,2.79,0,1.67-1.07C59.66,40.92,57.13,41.59,58.75,42.37Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M63.77,44.62c-.62,0-2.56-.19-1.83.92C62.6,46,65.47,45.49,63.77,44.62Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M58.75,45.61c.61,0,2.45.45,1.85-.76-.65-.68-3.57-.12-1.84.76Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M63.81,48c-.63-.17-2.7-.22-1.86.9.67.3,3.42.1,1.86-.91Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M60.2,47.94c-.76-.21-3,.31-1.45,1.08C59.52,49.17,61.79,48.75,60.2,47.94Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M62.29,52.35c.57-.09,1.9.34,2-.53-.11-1.21-3.89-.33-2,.53Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M60.19,51.38c-.72-.14-2.9-.05-1.5.95C59.48,52.71,61.8,52.15,60.19,51.38Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M55.15,45.73c.62-.08,2.51.28,1.83-.9C56.3,44.25,53.41,44.9,55.15,45.73Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M55.15,49c.61,0,2.51.3,1.82-.86-.67-.57-3.53,0-1.82.86Z" 
        transform="translate(0 0.04)"
      />
      <path 
        d="M56.6,51.31c-.77-.21-3,.29-1.45,1.07C55.92,52.54,58.2,52.1,56.6,51.31Z" 
        transform="translate(0 0.04)"
      />
    </StyledLogo>
  )
}

export default Logo
